import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';
import { useNestedDialogFunction } from '../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';
import React from 'react';
import { Controlled_AutocompleteReferenceTextField } from './Controlled_AutocompleteReferenceTextField';
import {
    ImageAttachmentEditDialog,
} from '../../../page-components/project/reusable-elements/attachment/ImageAttachmentEditDialog';
import {
    ImageAttachmentCreationDialog,
} from '../../../page-components/project/reusable-elements/attachment/ImageAttachmentCreationDialog';
import { useImageAttachmentActions } from '../../../../resource/resources/artifacts/attachment/imageAttachmentResource';
import { useSystemInformationActions } from '../../../../resource/services/systemInformationService';

export const Controlled_ImageAttachmentTextField= ({objectId, projectVersionId, onChange, readOnly, noLabel, propertyValidationInformation}: {
    objectId: string | undefined | null;
    projectVersionId: string | undefined | null;
    onChange?: (id: string | null) => void;
    readOnly: boolean;
    noLabel?: boolean;
    propertyValidationInformation: PropertyValidationInformation;
}) => {
    const nestedDialog = useNestedDialogFunction();

    const imageAttachmentActions = useImageAttachmentActions()
    const systemInformationActions = useSystemInformationActions()
    const imageAttachmentsQuery = imageAttachmentActions.useGetAllResources(projectVersionId);
    const propertyDetails = systemInformationActions.useGetPropertyDetails(
        propertyValidationInformation.propertyIdentifier,
        propertyValidationInformation.resourceType
    );
    const propertyValidation = systemInformationActions.useGetPropertyValidationWithId(
        propertyValidationInformation.propertyIdentifier,
        propertyValidationInformation.resourceType,
        propertyValidationInformation.resourceId ?? ''
    );

    const onEdit = () => {
        nestedDialog.showNestedDialog(
            <ImageAttachmentEditDialog
                onClose={nestedDialog.closeNestedDialog}
                objectId={objectId}
                versionedInId={projectVersionId ?? ""}
            />
        );
    };

    const onAdd = () => {
        nestedDialog.showNestedDialog(
            <ImageAttachmentCreationDialog
                onClose={nestedDialog.closeNestedDialog}
                parentId={projectVersionId ?? ""}
                onCreated={(_, newObjectId) => {
                    if (onChange) {
                        onChange(newObjectId);
                    }
                }}
            />
        );
    };

    return (
        <Controlled_AutocompleteReferenceTextField
            idValue={objectId}
            readOnly={readOnly}
            onChange={onChange}
            propertyValidation={propertyValidation}
            propertyDetails={noLabel ? undefined : propertyDetails}
            query={imageAttachmentsQuery}
            getOptionLabel={(option) => option.name}
            hideLabel={noLabel}
            onAdd={onAdd}
            onEdit={onEdit}
        />
    );
};